import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';
import { deobfuscateKey } from '@core/services/utils/key-obfuscator.util';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  // Llave fija para AES256 (32 bytes = 256 bits) - desofuscada en tiempo de ejecución
  private readonly secretKey: string = CryptoJS.enc.Utf8.parse(deobfuscateKey(environment._s3c));

  constructor() { }

  /**
   * Codifica una cadena usando AES256
   * @param plainText - Texto plano a codificar
   * @returns Cadena codificada en formato IV:ciphertext
   */
  xToZ(plainText: string): string {
    // Generar IV aleatorio de 16 bytes
    let iv = CryptoJS.lib.WordArray.random(16),
      ivHex = CryptoJS.enc.Hex.stringify(iv),

      // Encriptar usando AES256
      encrypted = CryptoJS.AES.encrypt(plainText, this.secretKey, {
        iv: iv,
        mode: CryptoJS.mode.CFB,
        padding: CryptoJS.pad.Pkcs7
      }),

      // Obtener el texto cifrado en Base64
      ciphertext = CryptoJS.enc.Base64.stringify(encrypted.ciphertext).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    // Retornar en formato IV:ciphertext
    return `${ivHex}:${ciphertext}`;
  }

  /**
   * Decodifica una cadena codificada en AES256
   * @param encryptedText - Texto codificado en formato IV:ciphertext
   * @returns Texto plano decodificado
   */
  private zToX(encryptedText: string): string {
    try {
      // Separar IV y ciphertext
      let [ivHex, ciphertextHex] = encryptedText.split(':');
      if (!ivHex || !ciphertextHex) throw new Error('Formato inválido.Debe ser IV:ciphertext');

      // Convertir IV de Hex a WordArray
      let iv = CryptoJS.enc.Hex.parse(ivHex),
        cipherParams = {
          ciphertext: CryptoJS.enc.Base64.parse(ciphertextHex),
          salt: '' as any
        } as any,
        // Desencriptar directamente desde el ciphertext en Base64
        decrypted = CryptoJS.AES.decrypt(cipherParams, this.secretKey, {
          iv: iv,
          mode: CryptoJS.mode.CFB,
          padding: CryptoJS.pad.Pkcs7
        }),
        // Convertir a string UTF-8
        plainText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!plainText) {
        throw new Error('Error al desencriptar. Verifica la clave y el formato.');
      }

      return plainText;
    } catch (error) {
      throw new Error(`Error en desencriptación: ${error instanceof Error ? error.message : 'Error desconocido'}`);
    }
  }
}